import { isFeatureEnabled } from '@luna/gatekeeper';

import {
    getContactByIdFromContacts,
    getPrimaryContact,
    isContactEntryAllowed,
} from './ContactService';
import type { Email } from './ContactTypes';
import { ContactListFlag } from './ContactDataManagementTypes';
import { getEmails } from './EmailsSourceService';

/** @deprecated useEmailById() acts as its replacement */
export function getEmailById(id?: string): Email | undefined {
    return getContactByIdFromContacts<Email>(id, getEmails());
}

export function getEmailByAddressFromEmails(
    emailAddress: string | undefined,
    emails: Email[],
): Email | undefined {
    return emails.find((email) => email.address === emailAddress);
}

/** @deprecated useEmailByAddress() acts as its replacement */
export function getEmailByAddress(emailAddress: string): Email | undefined {
    return getEmailByAddressFromEmails(emailAddress, getEmails());
}

export function getPrimaryEmail(): Email | undefined {
    return getPrimaryContact(getEmails());
}

export function isEmailEntryAllowed(flags: ContactListFlag[] | undefined): boolean {
    if (!isFeatureEnabled((f) => f.contactDataManagement) || !flags) {
        return false;
    }
    return isContactEntryAllowed(flags, ContactListFlag.EMAIL_NOT_ALLOWED);
}
